import { render } from "./EnemyDisplay.vue?vue&type=template&id=5c6f309c&scoped=true"
import script from "./EnemyDisplay.vue?vue&type=script&lang=js"
export * from "./EnemyDisplay.vue?vue&type=script&lang=js"

import "./EnemyDisplay.vue?vue&type=style&index=0&id=5c6f309c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6f309c"]])

export default __exports__